"use strict";
var toggle_controller_1 = require("./toggle.controller");
var templateUrl = require("./toggle.html");
exports.toggle = {
    templateUrl: templateUrl,
    controller: toggle_controller_1.ToggleController,
    controllerAs: "vm",
    bindings: {
        name: "@",
        onChange: "&",
        large: "@",
        value: "<",
        debounce: "@"
    }
};



/** WEBPACK FOOTER **
 ** ./app/common/toggle/toggle.ts
 **/